import { Component, Input } from '@angular/core';

import { isEmpty, isNotEmpty, isStringEqual, toShortDate } from '../../common/functions';

import { IAuditable } from '../../services/insecta';

@Component({
  selector: 'app-audit-info',
  standalone: true,
  imports: [],
  template: `<div class="flex {{ flow() }} audit-info p-0">
    <div class="audit-info-line mr-1">{{ actionText() }} on {{ actionDate() }}</div>
    <div class="audit-info-line">by {{ actionBy() }}</div>
  </div>`,
  styles: [
    `
      .audit-info {
        font-size: 0.75rem;
        color: gray;
      }
    `,
    `
      .audit-info-line {
        line-height: 0.75rem;
      }
    `
  ]
})
export class AuditInfoComponent {
  @Input() value: IAuditable | null = null;
  @Input() direction: 'horizontal' | 'vertical' = 'horizontal';

  public isVisble(): boolean {
    return isNotEmpty(this.value);
  }

  public actionText(): string {
    if (isEmpty(this.value?.action)) return ``;

    const action = this.value?.action ?? ``;
    return isStringEqual(action, 'INS')
      ? `Inserted`
      : isStringEqual(action, 'UPD')
        ? `Updated`
        : isStringEqual(action, 'DEL')
          ? `Deleted`
          : `Unknown Action`;
  }

  public actionDate(): string {
    if (isEmpty(this.value?.action)) return ``;
    return toShortDate(this.value?.actionOn);
  }

  public actionBy(): string {
    return this.value?.actionBy ?? `Unknown`;
  }

  public flow(): string {
    return isStringEqual(this.direction, 'horizontal') ? 'flex-row' : 'flex-column';
  }
}
